/**
 * Context model for sharing data across module
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");

    var LEConfig = require("assets/config/le-env-conf");
    var LE = require("app");

    var AutomationContextModel = {};

    // module definition args are optional, but help with encapsulation
    // I recommend making a macro/template in your editor of choice
    LE.module("LEAutomation", function (LEAutomation, LE, Backbone, Marionette, $, _) {
        AutomationContextModel = BaseModel.extend({

            defaults : {
                name : "AutomationContextModel",
                landingVideo: LEConfig.automationTabLandingVideo ? LEConfig.automationTabLandingVideo : 'https://player.vimeo.com/video/302277356'
            }
        });
    });

    return AutomationContextModel;
});
